import { InputComponent } from '@/shared/components/input.component';
import { Component, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'app-input-password',
  templateUrl: './input-password.component.html',
  styleUrls: ['./input-password.component.scss'],
})
export class InputPasswordComponent extends InputComponent<string> {
  @Input() mask: string = '';

  typeInput: string = 'password';

  constructor(@Optional() @Self() override ngControl: NgControl) {
    super(ngControl);
  }

  changeVision() {
    this.typeInput = this.typeInput === 'password' ? 'text' : 'password';
  }
}
